export const yesNoList = [
  { name: 'Yes', value: true },
  { name: 'No', value: false }
]
